module.exports = __webpack_public_path__ + "img/admin-organizaciones.b0e12853.svg";